import { render, staticRenderFns } from "./PerseoDashboard.vue?vue&type=template&id=063b0e69&scoped=true"
import script from "./PerseoDashboard.vue?vue&type=script&lang=js"
export * from "./PerseoDashboard.vue?vue&type=script&lang=js"
import style0 from "./PerseoDashboard.vue?vue&type=style&index=0&id=063b0e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b0e69",
  null
  
)

export default component.exports